module.exports = __webpack_public_path__ + "static/img/RK1264-G_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RK1264-G_1.png
// module id = ta2m
// module chunks = 0